// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1630873335253
      var cssReload = require("C:/Users/antoi/Desktop/FOLIO TEST/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  